import { appPaths, authPaths } from '@terminal/routes/app-paths';
import { widgetPaths } from '@terminal/views/widgets/widget-utils';

import { HeaderCategory } from '../header-navigation/components/category-group/HeaderCategoryGroup';

export const navigationKeys = {
  alerts: 'alerts',
  dashboard: 'dashboard',
  insightFeed: 'stream',
  alfred: 'alfred',
  chart: 'chart',
  events: 'events',
  news: 'news',
  help: 'help',
  settings: 'settings',
  signOut: 'signOut',
  screener: 'screener',
  scenario: 'scenario',
  search: 'searchAsset',
  feedback: 'feedback',
  watchlist: 'watchlist',
  insights: 'insights',
  research: 'research',
  onboarding: 'onboarding',
  subscription: 'subscription',
  portfolio: 'portfolio',
  appearance: 'appearance',
  more: 'more',
};

export const mapNavigationKeyToPathname = {
  [navigationKeys.settings]: appPaths.settings.account,
  [navigationKeys.subscription]: appPaths.settings.subscription,
  [navigationKeys.portfolio]: appPaths.settings.portfolio,
  [navigationKeys.appearance]: appPaths.settings.appearance,
  [navigationKeys.alfred]: appPaths.alfred,
  [navigationKeys.research]: appPaths.research,
  [navigationKeys.screener]: appPaths.screener,
  [navigationKeys.insights]: appPaths.insights,
  [navigationKeys.events]: appPaths.events,
  [navigationKeys.chart]: appPaths.chart,
  [navigationKeys.news]: appPaths.news,
  [navigationKeys.signOut]: authPaths.login,
  [navigationKeys.watchlist]: appPaths.watchlist,
  [navigationKeys.scenario]: appPaths.scenario,
  [navigationKeys.search]: `${appPaths.base}?widget=${widgetPaths.searchAsset}`,
  [navigationKeys.dashboard]: appPaths.base,
  [navigationKeys.insightFeed]: appPaths.insightFeed,
  [navigationKeys.alerts]: appPaths.alerts,
};

export const mapNavigationKeyToRegex = {
  [navigationKeys.alfred]: new RegExp(appPaths.alfred),
  [navigationKeys.research]: new RegExp(appPaths.research),
  [navigationKeys.screener]: new RegExp(appPaths.screener),
  [navigationKeys.chart]: new RegExp(appPaths.chart),
  [navigationKeys.events]: new RegExp(appPaths.events),
  [navigationKeys.news]: new RegExp(appPaths.news),
  [navigationKeys.scenario]: new RegExp(appPaths.scenario),
  [navigationKeys.insights]: new RegExp(appPaths.insights),
  [navigationKeys.dashboard]: new RegExp(`${appPaths.base}\/?$`),
  [navigationKeys.signOut]: new RegExp(authPaths.login),
  [navigationKeys.watchlist]: new RegExp(appPaths.watchlist),
  [navigationKeys.settings]: new RegExp(appPaths.settings.base),
  [navigationKeys.insightFeed]: new RegExp(appPaths.insightFeed),
  [navigationKeys.alerts]: new RegExp(appPaths.alerts),
};

const pathMatcher = (pathname: string, regexp?: RegExp) =>
  regexp?.test(pathname);

// gets the active key from location.pathname
// /app/screener/:id --> navigationKeys.screener
export const getActiveNavigationKey = (categories: HeaderCategory[]) => {
  const items = categories.flatMap(c => c.items);

  return items.find(item =>
    pathMatcher(location.pathname, mapNavigationKeyToRegex[item.key])
  )?.key;
};

type NavigationKeys = keyof typeof navigationKeys;

export const isPathMatches = (
  keys: NavigationKeys[],
  pathname = location.pathname
) => keys.some(key => pathMatcher(pathname, mapNavigationKeyToRegex[key]));

export const isNewTabClick = (e?: React.MouseEvent) =>
  !!(e?.metaKey || e?.ctrlKey);
